import { useStaticQuery, graphql } from 'gatsby';

const useFullDealersData = () => {
    const dealersData = useStaticQuery(graphql`
        query distributors {
            wordpress {
                dealers(first: 10000) {
                    nodes {
                        title
                        featuredImage {
                            node {
                                altText
                                sourceUrl
                                imageFile {
                                    childImageSharp {
                                        fluid(maxWidth: 1140) {
                                            ...GatsbyImageSharpFluid_withWebp_tracedSVG
                                        }
                                    }
                                }
                            }
                        }
                        ACFDealerBlockFields {
                            address
                            country
                            dealerCountry
                            email
                            publicEmail
                            information
                            language
                            phone
                            website
                            location {
                                city
                                country
                                countryShort
                                latitude
                                longitude
                                placeId
                                postCode
                                state
                                stateShort
                                streetAddress
                                streetName
                                streetNumber
                                zoom
                            }
                            dealerLocation {
                                latitude
                                longitude
                            }
                            employees {
                                email
                                location
                                name
                                phone
                                image {
                                    altText
                                    sourceUrl
                                    imageFile {
                                        childImageSharp {
                                            fluid(maxWidth: 320) {
                                                ...GatsbyImageSharpFluid_withWebp_tracedSVG
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    `);

    return dealersData.wordpress.dealers.nodes;
};

export default useFullDealersData;
